import { render, staticRenderFns } from "./ContentElements.vue?vue&type=template&id=06daf058"
import script from "./ContentElements.vue?vue&type=script&lang=js"
export * from "./ContentElements.vue?vue&type=script&lang=js"
import style0 from "./ContentElements.vue?vue&type=style&index=0&id=06daf058&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports